var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFutureBaby = function SvgFutureBaby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEF3C6",
    d: "M17.875 7.25c1.348 0 2.52 1.113 2.52 2.52v3.75c0 1.347-1.172 2.46-2.52 2.46h-2.52v3.692a14 14 0 0 0 2.11-1.582l1.758 1.758c-2.285 2.226-5.391 3.633-8.848 3.633s-6.562-1.407-8.848-3.633l1.758-1.758a14 14 0 0 0 2.11 1.582V15.98h-2.52c-1.348 0-2.52-1.113-2.52-2.46v-7.5c0-2.754 2.286-5.04 5.04-5.04h4.98v6.27zm-4.98 13.418v-4.687h-5.04v4.687c.82.234 1.641.352 2.52.352s1.7-.118 2.52-.352m4.98-7.148V9.77H7.855V3.5h-2.46a2.5 2.5 0 0 0-2.52 2.52v7.5z"
  })));
};
export default SvgFutureBaby;